<script setup lang="ts">
import { RouterView } from 'vue-router';
import { useAuthStore } from './stores/auth';
import AppSidebar from './components/AppSidebar.vue';

const authStore = useAuthStore();
</script>

<template>
  <div class="app-layout" :class="{ 'has-sidebar': authStore.isAuthenticated }">
    <AppSidebar v-if="authStore.isAuthenticated" />
    <main class="main-content">
      <RouterView />
    </main>
  </div>
</template>

<style scoped>
.app-layout {
  min-height: 100vh;
  display: flex;
  background: var(--bg-primary);
}

.main-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.has-sidebar .main-content {
  margin-left: var(--sidebar-width);
}

@media (max-width: 768px) {
  .has-sidebar .main-content {
    margin-left: 0;
  }
}
</style>
